import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React, { Fragment, useCallback, useState } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import { getThemeEventSelectorId } from '../../utils/hsAnalytics'; // @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module './Th... Remove this comment to see the full error message

import ThemeDemoModal from './ThemeDemoModal';

const ThemeDemoButton = (_ref) => {
  let {
    exampleUrl,
    modalPrimaryButton,
    name,
    onClick,
    onTrackInteraction,
    onTrackPageview,
    providerName,
    section
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["exampleUrl", "modalPrimaryButton", "name", "onClick", "onTrackInteraction", "onTrackPageview", "providerName", "section"]);

  const [modalOpen, setModalOpen] = useState(false);
  const handleClick = useCallback(evt => {
    setModalOpen(true);
    onTrackInteraction('click preview button', {
      section
    });

    if (onClick) {
      onClick(evt);
    }
  }, [onClick, onTrackInteraction, section]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(UIButton, Object.assign({}, rest, {
      "data-hs-analytics-id": getThemeEventSelectorId('PREVIEW'),
      onClick: handleClick,
      use: "secondary",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.details.demoButton"
      })
    })), modalOpen && /*#__PURE__*/_jsx(ThemeDemoModal, {
      exampleUrl: exampleUrl,
      name: name,
      onClose: () => {
        setModalOpen(false);
      },
      onTrackInteraction: onTrackInteraction,
      onTrackPageview: onTrackPageview,
      primaryButton: modalPrimaryButton,
      providerName: providerName,
      showShareButton: true
    })]
  });
};

export default ThemeDemoButton;